import BaseApi from '../BaseApi';
// 电池箱左侧接口
let API='screenBatteryBox'
export default class BatteryBoxApi extends BaseApi {
  // ***************************电池信息begin***************************
  // 1.获取电池指标信息
  async selectBatteryInfo(info) {
    return await this.get(`${API}/selectBatteryInfo`, info);
  }
  // 2.获取充电过程电池信息
  async chargingProcessInfo(info) {
    return await this.get(`${API}/chargingProcessInfo`, info);
  }
  // 3.获取电池预警信息
  async batterAlarmInfo(info) {
    return await this.get(`${API}/batterAlarmInfo`, info);
  }
  // 4.获取中间电池信息
  async centerBatterInfo(info) {
    return await this.get(`${API}/centerBatterInfo`, info);
  }
  // 6.获取充电实时监测折线图
  async chargeLineMap(info) {
    return await this.get(`${API}/chargeLineMap`, info);
  }
  // 获取电池包信息
  async getBatteryPackageInfo(info) {
    return await this.get(`${API}/getBatteryPackageInfo`, info);
  }
  // 获取电池包温度信息
  async selectbatteryPackTemperature(info) {
    return await this.get(`screenBatteryInfo/selectbatteryPackTemperature`, info);
  }
  
  // ***************************电池信息end***************************
}
export const batteryBoxLeft = new BatteryBoxApi();